import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { formInputTheme } from "./formInputTheme";
// not using sizing constant due to the 2px border (would be 12/sizes.small)
export var StyledContentBeforeContainer = styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-left: ", ";\n    display: flex;\n"])), getPadding);
function getPadding(_ref) {
  var themeMode = _ref.themeMode,
    validationState = _ref.validationState;
  if (validationState === "error") {
    return formInputTheme.padding.left.error(themeMode);
  } else {
    return formInputTheme.padding.left.rest(themeMode);
  }
}
//# sourceMappingURL=StyledContentBeforeContainer.js.map